export class InputFollowupFileToUpload {
    base64: string;
    mimetype: string;
    filename: string;
    file_extension: string;
}